import React from 'react';
import { pick, prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { Link } from 'js/components/common/Link';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import style from './Logo.scss';

export const Logo: React.FC = () => {
    const formFactor = useDeviceSelector(prop('formFactor'));
    const {
        customization: { siteLogoPath = '' } = {}, requestStamp, themeName, siteLogoConfigurations
    } = useAppSelector(pick([
        'customization', 'requestStamp', 'themeName', 'siteLogoConfigurations'
    ]));
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const casinoname = searchParams.get('casinoname');
    const site = searchParams.get('site');
    const params = new URLSearchParams({
        t: `${requestStamp}`,
        ...casinoname && { casinoname },
        ...site && { site }
    });
    const logoURL = siteLogoPath
        ? `${siteLogoPath}?${params.toString()}`
        : `/${themeName}/images/logo.png?${params.toString()}`;
    const { siteLogoWidth, siteLogoHeight } = siteLogoConfigurations[formFactor];

    return (
        <div className={`${style.logo} cms-default-header-logo`}>
            <Link href="/">
                <img
                    alt="logo"
                    src={logoURL}
                    style={{ width: siteLogoWidth, height: siteLogoHeight }}
                    className={`${style.logoImage} cms-default-header-logo-image`}
                />
            </Link>
        </div>
    );
};
